import React, { useEffect, useState } from 'react';
import { UpOutlined } from '@ant-design/icons';

import { Content } from './Content';
import { TitleCustom } from './TitleCustom';

import * as S from './styles';

const renderExpandIcon = ({ isActive }) => (
  <UpOutlined
    style={{
      fontSize: '18px',
      fontWeight: 'bold',
    }}
    rotate={isActive ? 0 : 180}
  />
);

export function CollapseCustom({ data, btnDisabled, dataAtendimento }) {
  const [consulta, setConsulta] = useState({});

  useEffect(() => {
    const countNote = consulta?.data?.observacao?.trim()?.length >= 10;

    btnDisabled(!countNote);
    const payload = {
      id: consulta?.data?.id,
      observacao: consulta?.data?.observacao,
    };
    dataAtendimento([payload]);
  }, [consulta, btnDisabled, dataAtendimento]);

  const collapseItems = data?.map((item, index) => ({
    key: index.toString(),
    label: <TitleCustom origem={item?.nomeConsulta || ''} />,
    children: <Content data={item} change={setConsulta} />,
  }));

  return (
    <S.CollapsContainer
      accordion
      ghost
      defaultActiveKey="0"
      expandIconPlacement="end"
      expandIcon={renderExpandIcon}
      items={collapseItems}
    />
  );
}
